import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { PostComment } from "@domain/post/comment/postComment";
import { Person } from "@domain/user/user";
import { gap } from "@ui/styles/utils";
import { TertiaryButton } from "@ui/components/buttons/tertiaryButton";
import { CommentInput } from "./commentInput";

interface CommentEditorProps extends React.HTMLAttributes<HTMLDivElement> {
	postId: string;
	onCommentSubmit: (comment?: PostComment) => void;
	onCancel: () => void;
	initialComment?: PostComment;
	parentId?: string;
	replyTo?: Person;
}
export const CommentEditor: React.FC<CommentEditorProps> = ({
	postId,
	onCommentSubmit,
	onCancel,
	initialComment,
	parentId,
	replyTo,
	...htmlProps
}) => {
	return (
		<Container {...htmlProps} tabulated={!initialComment}>
			<CommentInput
				postId={postId}
				initialComment={initialComment}
				onCommentSubmit={onCommentSubmit}
				placeholder={parentId ? I18n.t("post.comment.reply.placeholder") : I18n.t("post.comment.input.placeholder")}
				replyTo={replyTo}
				parentId={parentId}
			/>
			<TertiaryButton onClick={onCancel}>{I18n.t("cancel")}</TertiaryButton>
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "tabulated",
})<{ tabulated?: boolean }>`
	margin-left: ${({ tabulated }) => (tabulated ? 46 : 0)}px;
	${gap(6)};
	> button {
		${({ theme }) => theme.textStyles.text};
		color: ${({ theme }) => theme.colors.secondary};
		margin-left: 48px;
	}
`;
